import { render, staticRenderFns } from "./EntityLeaveDialog.vue?vue&type=template&id=1bc07c74&"
import script from "./EntityLeaveDialog.vue?vue&type=script&lang=js&"
export * from "./EntityLeaveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports